import { createAsyncThunk } from '@reduxjs/toolkit';
import employeeServiceApiInstance from '../../../../config/employeeApiConfig';


export const fetchAllDailyReport = createAsyncThunk(
    'report/fetchAllDailyReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/report/daily');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Daily Reports');
        }
    }
);
export const fetchAllDailyCount = createAsyncThunk(
    'report/fetchAllDailyReport',
    async (_, { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get('/report/daily/count');
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Daily Reports');
        }
    }
);
export const fetchAllDailyAttendanceMonthly = createAsyncThunk(
    'report/fetchAllDailyReport',
    async (year : string , { rejectWithValue }) => {
        try {
            const response = await employeeServiceApiInstance.get(`/report/daily/monthlyattendance/${year}`);
            return response.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all Daily Reports Attendance');
        }
    }
);